import { RouteObject } from "react-router-dom";
import { assetsRoutes } from "./assetRegistry/assets/routes";
import { axFacilitiesRoutes } from "./assetRegistry/facilities/routes";
import { systemsRoutes } from "./assetRegistry/systems/routes";
import { axDashboardRoutes } from "./dashboard/routes";

import { axIncidentRoutes } from "./fieldAlerts/incidents";

import { assetClassificationRoutes } from "./settings/assetClassification/routes";
import { conditionalParametersRoutes } from "./settings/conditionalParameters/routes";
import { criticalParametersRoutes } from "./settings/criticalParameters/routes";
import { facilityTypesRoutes } from "./settings/facilityTypes/routes";
import { manufacturersRoutes } from "./settings/manufacturers/routes";
import { networkManagementRoutes } from "./settings/networkManagement/routes";
import { systemTypesRoutes } from "./settings/systemTypes/routes";
import { axServiceOrder } from "./srvc-and-mgmt/service-order/routes";
import { systemAlertsRoutes } from "./srvc-and-mgmt/systemAlerts";
import { scheduleRoutes } from "./srvc-and-mgmt/schedule/routes";
import { networksRoutes } from "./assetRegistry/networks";
import { axFieldAlerts } from "./fieldAlerts/failure";

export interface AxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: AxRoute[];
}

export const axRoutes: AxRoute[] = [
  ...manufacturersRoutes,
  ...axServiceOrder,
  ...axFieldAlerts,
  ...networksRoutes,
  ...assetsRoutes,
  ...systemAlertsRoutes,
  ...axDashboardRoutes,
  ...axFacilitiesRoutes,
  ...axIncidentRoutes,
  ...assetClassificationRoutes,
  ...facilityTypesRoutes,
  ...networkManagementRoutes,
  ...conditionalParametersRoutes,
  ...criticalParametersRoutes,
  ...systemTypesRoutes,
  ...systemsRoutes,
  ...scheduleRoutes,
];
